(() => {
  if (window.__swanMagic360IntegrationLoaded) return;
  window.__swanMagic360IntegrationLoaded = true;

  const gallerySelector = 'media-gallery[data-swan-magic360-count]';

  const restoreHorizonGallery = (gallery) => {
    const mediaRoot = gallery.closest('.product-information__media');
    const wrapper = gallery.parentElement;

    if (!mediaRoot || !wrapper || wrapper === mediaRoot) return;

    /*
     * Magic 360 moves the Horizon gallery to:
     * position:absolute; top:-10000px; width:1px; height:1px;
     *
     * Remove those hiding styles without altering the gallery itself.
     */
    wrapper.classList.add('swan-magic360-native-wrapper');

    [
      'position',
      'top',
      'right',
      'bottom',
      'left',
      'inset',
      'width',
      'height',
      'overflow'
    ].forEach((property) => {
      wrapper.style.removeProperty(property);
    });
  };

  const createThumbnail = (activate360) => {
    const button = document.createElement('button');

    button.type = 'button';
    button.className =
      'slideshow-control button button-unstyled slideshow-controls__thumbnail swan-magic360-thumbnail';

    button.setAttribute('aria-label', 'View product in 360 degrees');
    button.setAttribute('aria-selected', 'false');

    button.innerHTML = `
      <span class="swan-magic360-thumbnail__content" aria-hidden="true">
        <svg viewBox="0 0 32 32">
          <path d="M25.8 10.2A11.5 11.5 0 1 0 27.5 20"></path>
          <path d="M25.8 4.8v5.4h-5.4"></path>
          <path d="M8.2 21.8A11.5 11.5 0 0 0 22 26.2"></path>
        </svg>
        <span class="swan-magic360-thumbnail__text">360°</span>
      </span>
    `;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      activate360();
    });

    return button;
  };

  const initializeGallery = (gallery) => {
    if (gallery.dataset.swanMagic360Ready === 'true') {
      return true;
    }

    const mediaRoot = gallery.closest('.product-information__media');
    if (!mediaRoot) return false;

    const magicBlock = mediaRoot.querySelector('#magic-360-block');
    const spinSlide = magicBlock?.querySelector(
      '.MagicToolboxSlide[data-slide-id="spin"]'
    );
    const slideshowContainer = gallery.querySelector('slideshow-container');

    /*
     * Wait until the Magic 360 app finishes generating its viewer.
     */
    if (!magicBlock || !spinSlide || !slideshowContainer) {
      return false;
    }

    restoreHorizonGallery(gallery);

    const stage = document.createElement('div');
    stage.className = 'swan-magic360-stage';
    stage.hidden = true;
    stage.setAttribute('aria-hidden', 'true');

    slideshowContainer.appendChild(stage);
    stage.appendChild(magicBlock);

    /*
     * Keep only the spin slide active inside the app.
     */
    magicBlock
      .querySelectorAll('.MagicToolboxSlide')
      .forEach((slide) => {
        if (slide === spinSlide) {
          slide.classList.add('active-magic-slide');
        } else {
          slide.classList.remove('active-magic-slide');
        }
      });

    const customButtons = [];

    const activate360 = () => {
      /*
       * Use the app's own spin selector so Magic 360 handles its
       * internal state rather than recreating any app functionality.
       */
      const originalSpinSelector = magicBlock.querySelector(
        '.MagicToolboxSelectorsContainer [data-slide-id="spin"]'
      );

      if (originalSpinSelector) {
        originalSpinSelector.click();
      }

      stage.hidden = false;
      stage.setAttribute('aria-hidden', 'false');
      gallery.classList.add('swan-magic360-active');

      customButtons.forEach((button) => {
        button.setAttribute('aria-selected', 'true');
      });

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    };

    const deactivate360 = () => {
      stage.hidden = true;
      stage.setAttribute('aria-hidden', 'true');
      gallery.classList.remove('swan-magic360-active');

      customButtons.forEach((button) => {
        button.setAttribute('aria-selected', 'false');
      });
    };

    /*
     * Add the custom button to every Horizon thumbnail group.
     * This covers both desktop and mobile thumbnail controls.
     */
    gallery
      .querySelectorAll('.slideshow-controls__thumbnails')
      .forEach((thumbnailGroup) => {
        if (
          thumbnailGroup.querySelector('.swan-magic360-thumbnail')
        ) {
          return;
        }

        const button = createThumbnail(activate360);
        const firstProductThumbnail = thumbnailGroup.querySelector(
          ':scope > .slideshow-controls__thumbnail'
        );

        /*
         * Place 360 immediately after the primary product image.
         * Use thumbnailGroup.prepend(button) if you want it first.
         */
        if (firstProductThumbnail) {
          firstProductThumbnail.insertAdjacentElement('afterend', button);
        } else {
          thumbnailGroup.appendChild(button);
        }

        customButtons.push(button);
      });

    /*
     * Selecting any regular thumbnail or slideshow arrow returns
     * the gallery to standard Horizon image mode.
     */
    gallery.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('.swan-magic360-thumbnail')) {
        return;
      }

      const regularThumbnail = event.target.closest(
        '.slideshow-controls__thumbnail'
      );
      const slideshowArrow = event.target.closest(
        'slideshow-arrows button'
      );

      if (regularThumbnail || slideshowArrow) {
        deactivate360();
      }
    });

    gallery.dataset.swanMagic360Ready = 'true';

    return true;
  };

  const initializeAll = () => {
    let everythingReady = true;

    document.querySelectorAll(gallerySelector).forEach((gallery) => {
      if (!initializeGallery(gallery)) {
        everythingReady = false;
      }
    });

    return everythingReady;
  };

  const start = () => {
    if (initializeAll()) return;

    /*
     * The app embed normally loads after the Horizon gallery,
     * so watch briefly for Magic 360 to finish rendering.
     */
    const observer = new MutationObserver(() => {
      if (initializeAll()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(() => {
      observer.disconnect();
    }, 20000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }

  /*
   * Reinitialize when Shopify reloads the section inside
   * the theme customizer.
   */
  document.addEventListener('shopify:section:load', start);
})();